export const es = {
    title: `Bienvenido de nuevo`,
    description: `Ingresa tus credenciales para acceder a tu cuenta`,
    forgotPassword: `¿Olvidaste tu contraseña?`,
    noAccount: `¿No tienes una cuenta?`,
    failure: `Error al iniciar sesión`,
};
//# sourceMappingURL=es.js.map